<template>
  <div>
    <router-view />
  </div>
</template>
<script>

export default {
  name: "TruckIndex",
  data () {
    return {}
  },
  created () {

  },
  methods: {
  
  },
}

</script>
